const DEVICE_ID_KEY = 'dfl-device-id';
const PUSH_SUBSCRIBED_KEY = 'dfl-push-subscribed';

// The auth library calls localStorage.clear() on logout, which wipes the
// deviceId and makes the next login register a brand-new device (duplicates +
// unique-key clashes on the backend). A cookie survives localStorage.clear(),
// so we keep the deviceId in a long-lived cookie as the source of truth and
// mirror it to localStorage for fast synchronous reads.
const DEVICE_ID_MAX_AGE = 60 * 60 * 24 * 365 * 10; // 10 years

const readCookie = (name: string): string | null => {
  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=')[1]) : null;
};

const writeCookie = (name: string, value: string): void => {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${DEVICE_ID_MAX_AGE}; SameSite=Lax`;
};

export const getDeviceId = (): string => {
  // Cookie first (survives logout's localStorage.clear()), then localStorage.
  const stored = readCookie(DEVICE_ID_KEY) || localStorage.getItem(DEVICE_ID_KEY);
  if (!stored) {
    // Re-seed both stores in case one of them was cleared.
    const deviceId = crypto.randomUUID();
    writeCookie(DEVICE_ID_KEY, deviceId);
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
    return deviceId;
  }
  return stored;
};

export const isPushSubscribed = (): boolean => localStorage.getItem(PUSH_SUBSCRIBED_KEY) === 'true';

export const setPushSubscribed = (subscribed: boolean): void => {
  if (subscribed) {
    localStorage.setItem(PUSH_SUBSCRIBED_KEY, 'true');
  } else {
    localStorage.removeItem(PUSH_SUBSCRIBED_KEY);
  }
};
